import { stripRoutePrefix } from 'services/theming';

/**
 * True when harvester is printing the reports page, the one page still printed from the
 * market. A signed-in user's own token is used as usual; without one, harvester authenticates
 * the page's gapi requests itself.
 */
export const isHeadless = () =>
  stripRoutePrefix(window.location.pathname).replace(/\/+$/, '') === '/reports' &&
  new URLSearchParams(window.location.search).has('headless');
